import script from "./ProcessInfo.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProcessInfo.vue?vue&type=script&setup=true&lang=ts"

import "./ProcessInfo.vue?vue&type=style&index=0&id=2b21b354&scoped=true&lang=css"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b21b354"]])

export default __exports__